import React from 'react';
import { ITimestamp } from './IEditor';
import { parseSessionTimestamp } from '../../shared/TimestampUtils';

export default function TimestampSection({
    timestamp,
  isFirst,
}: {
  timestamp: ITimestamp;
  isFirst: boolean;
}) {
  const { value } = timestamp;

  const parsed = parseSessionTimestamp(value);

  if (!parsed) return null;

  const { year, month, day, hour, minute, second } = parsed;

  return (
    <div
      contentEditable={false}
      style={{
        userSelect: 'none',
        width: 'fit-content',
        marginBottom: 10,
        marginTop: isFirst ? 0 : 30,
      }}
    >
      <span
        contentEditable={false}
        className="timestamp_span"
        style={{ borderColor: `#2b8dff` }}
      >
        {day}.{month}.{year} {hour}:{minute}:{second}
      </span>
    </div>
  );
}
